import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Please check your mailbox and follow instructions. ", -1);
const _hoisted_3 = {
  class: "d-flex align-items-center justify-content-between"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_input = _resolveComponent("app-input");
  const _component_app_link = _resolveComponent("app-link");
  const _component_app_form = _resolveComponent("app-form");
  const _component_the_wrapper_public = _resolveComponent("the-wrapper-public");
  return _openBlock(), _createBlock(_component_the_wrapper_public, {
    title: "Create an Account",
    scrollable: false
  }, {
    default: _withCtx(() => [$data.showSuccessMessage ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("p", null, [_createTextVNode(" We sent a message to "), _createElementVNode("b", null, _toDisplayString($data.form.email), 1), _createTextVNode(". ")]), _hoisted_2, _createVNode(_component_app_button, {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.replace('/login'))
    }, {
      default: _withCtx(() => [_createTextVNode(" Back to Login ")]),
      _: 1
    })])) : (_openBlock(), _createBlock(_component_app_form, {
      key: 1,
      novalidate: "",
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_app_input, {
        modelValue: $data.form.first_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.first_name = $event),
        validateRule: "name",
        type: "text",
        label: "First Name",
        placeholder: "Please enter your first name",
        required: "",
        onSubmit: $options.onSubmit
      }, null, 8, ["modelValue", "onSubmit"]), _createVNode(_component_app_input, {
        modelValue: $data.form.last_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.last_name = $event),
        validateRule: "name",
        type: "text",
        label: "Last Name",
        placeholder: "Please enter your last name",
        required: "",
        onSubmit: $options.onSubmit
      }, null, 8, ["modelValue", "onSubmit"]), _createVNode(_component_app_input, {
        modelValue: $data.form.email,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.email = $event),
        validateRule: "email",
        type: "email",
        label: "Email",
        placeholder: "Please enter your email",
        required: "",
        onSubmit: $options.onSubmit
      }, null, 8, ["modelValue", "onSubmit"]), _createVNode(_component_app_input, {
        modelValue: $data.form.password,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.password = $event),
        validateRule: "password",
        type: "password",
        label: "Password",
        placeholder: "Please enter your password",
        description: "Password should contains at least 8 characters and only alphanumeric characters",
        required: "",
        onSubmit: $options.onSubmit
      }, null, 8, ["modelValue", "onSubmit"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_app_button, {
        loading: $data.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [_createTextVNode(" Sign Up ")]),
        _: 1
      }, 8, ["loading"]), _createVNode(_component_app_link, {
        variant: "link",
        onClick: _cache[5] || (_cache[5] = $event => _ctx.$router.replace('/login'))
      }, {
        default: _withCtx(() => [_createTextVNode(" Back to Login ")]),
        _: 1
      })])]),
      _: 1
    }, 8, ["onSubmit"]))]),
    _: 1
  });
}